module.exports = __webpack_public_path__ + "img/tf.e38b800c.svg";